import styled, { keyframes } from 'styled-components';
import React from 'react';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const TimeLineContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: center;
  width: ${(p) => (p.width ? p.width : '75%')};
  max-width: 500px;
  @media only screen and (max-width: 1209px) {
    width: 75%;
  }
  @media only screen and (max-width: 1100px) {
    width: 100%;
  }

  @media only screen and (max-width: 870px) {
    width: ${(p) => (p.width ? p.width : '50%')};
  }
`;
export const ToolTipContainer = styled.div`
  cursor: pointer;
  margin-left: -5px;
  align-self: center;
`;
export const TimeLineLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const TimeLineLabel = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  color: ${(props) =>
    props.$isSbmReferral
      ? props.$status !== 'completed'
        ? '#0E9CFF'
        : '#FFFFFF'
      : props.$status === 'processing'
      ? '#FE0095'
      : props.$status === 'pending'
      ? '#747474'
      : props.$status === 'completed'
      ? '000000'
      : '#747474'};
`;
export const TimeLineDotContainer = styled.div`
  width: 103%;
  display: flex;
  justify-content: flex-end;

  position: absolute;
  right: -7px;
  top: -5px;
`;
const blink = keyframes`
 from, to {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
`;
export const TimeLineActiveDot = styled.div`
  width: 4px;
  height: 4px;
  background-color: ${COLORS.lightGreen};
  border-radius: 4px;
  animation: 1s ${blink} ease infinite;
`;
export const TimelineSeparator = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="2" viewBox="0 0 11 2">
    <g fill="#E8E8E8" fillRule="evenodd">
      <circle cx="1" cy="1" r="1" />
      <circle cx="4" cy="1" r="1" />
      <circle cx="7" cy="1" r="1" />
      <circle cx="10" cy="1" r="1" />
    </g>
  </svg>
);

export const MobileTimeLineContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
`;
export const BackButton = styled.div`
  display: flex;
`;
export const StepContainer = styled.div`
  display: flex;
  margin-left: 8px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;

  letter-spacing: 0.75px;
  color: ${(props) => (props.$isSbmReferral ? '#FFFFFF' : '#000000')};
`;

export const StepIPContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
export const IPMobileContainer = styled.div`
  max-width: 130px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  div:nth-child(2) {
    margin-top: 2px;
    margin-left: 5px;
  }
`;
export const IP = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 8px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.17px;
  color: ${COLORS.brandPrimary};

  text-align: center;
  align-self: center;

  > span {
    color: #96a4b9;
  }
`;
export const ActiveStep = styled.div`
  color: ${(props) => (props.$isSbmReferral ? '#0E9CFF' : '#FE0095')};
  margin-left: 5px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
`;
